import styled from '@emotion/styled';
import Info from '@engineering/icons/info';
import { Ui } from '@silvertours/front-shared';

type AffiliateProps = {
  isAffiliate?: boolean;
  hasCustomColor?: boolean;
};

const Badge = styled.div<AffiliateProps>`
  position: absolute;
  right: 0;
  top: -1.625rem;
  height: 2.125rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: ${({ theme }) => theme.colors.brand.orange100};
  background-image: ${({ theme }) =>
    theme.linearGradient(theme.gradient.orange, 'to left')};
  color: ${({ theme }) => theme.colors.neutral.grey160};
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-weight: 700;
  padding: 0 1rem;
  border-radius: ${({ theme }) => theme.radius.round};

  ${({ theme }) => theme.mq('md')} {
    top: 0.625rem;
    right: -0.625rem;
  }

  svg {
    width: 1.6rem;
    height: 1.6rem;
    fill: ${({ theme }) => theme.colors.neutral.grey160};
    vertical-align: middle;
    cursor: pointer;
  }
`;

const StyledTooltip = styled(Ui.Tooltip)`
  &:focus-visible {
    border-radius: 100%;
    outline-color: currentcolor;
  }
`;

const InfoIcon = styled(Info)`
  width: 1.6rem;
  height: 1.6rem;
  fill: currentcolor;
  vertical-align: middle;
  cursor: pointer;
`;

export { Badge, InfoIcon, StyledTooltip };
